
import ProgressBar from '@core/components/ProgressBar'
import FormattedMessage from '@i18n/components/FormattedMessage'

import translations from './StatLine.translations'

export default {
  components: {
    FormattedMessage,
    ProgressBar,
  },
  props: {
    intervals: {
      type: String,
      required: true,
    },
    percentage: {
      type: Number,
      required: true,
    },
  },
  computed: {
    translations: () => translations,
  },
}
